export const typeConvertor: Record<string, string> = {
  sale: 'حراجی',
  auction: 'مزایده',
  prepayment: 'سلف',
  simple: 'سطح کیفیت معین',
};
